function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollectionsSalesAnalytics = function SvgCollectionsSalesAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54339",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19935",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17878",
    d: "M10 10V6H6a3.837 3.837 0 0 0-4 4v28a4.012 4.012 0 0 0 4 4s24.931.012 28 0 4-1.749 4-4v-4h-4v4H6V10zm28-8H14a4.012 4.012 0 0 0-4 4v24a4.012 4.012 0 0 0 4 4h24a4.012 4.012 0 0 0 4-4V6a4.012 4.012 0 0 0-4-4zm0 28H14V6h9v13l6-4.5 6 4.5V6h3z",
    transform: "translate(6 6)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgCollectionsSalesAnalytics;